
const SliderReducer = (state = {range: 5}, action) => {
    if (action.type === "SET_RANGE")
        return {
            ...state,
            range: action.payload
        }
    return state;
}
export default SliderReducer;